/**
 * Veeso Billing API definitions
 */

import { defHTTP } from '../../api-builder';
import type {
  UsageResponse,
  UsageRecordsParams,
  UsageRecordsResponse,
  DailyCreditsStatusResponse,
  ClaimDailyCreditsResponse,
  OrderParams,
  OrdersResponse,
  InvoiceData,
  InvoiceResponse,
  InvoicesResponse,
  Invoice,
} from './types';

/**
 * Billing API definitions for use with apiBuilder
 */
export const billingAPIDefinitions = {
  /**
   * Get usage statistics
   */
  getUsage: defHTTP<void, UsageResponse>('GET', '/billing/usage'),

  /**
   * Get usage records
   */
  getUsageRecords: defHTTP<UsageRecordsParams, UsageRecordsResponse>(
    'GET',
    '/billing/usage/records'
  ),

  /**
   * Get daily credits claim status
   */
  getDailyCreditsStatus: defHTTP<void, DailyCreditsStatusResponse>('GET', '/credits/daily/status'),

  /**
   * Claim daily credits
   */
  claimDailyCredits: defHTTP<void, ClaimDailyCreditsResponse>('POST', '/credits/daily'),

  /**
   * Get orders list
   */
  getOrders: defHTTP<OrderParams, OrdersResponse>('GET', '/v1/checkout'),

  /**
   * Apply for invoice
   */
  applyInvoice: defHTTP<InvoiceData, InvoiceResponse>('POST', '/api/invoice'),

  /**
   * Get invoices list
   */
  getInvoices: defHTTP<OrderParams, InvoicesResponse>('GET', '/api/invoice'),

  /**
   * Get invoice detail
   */
  getInvoiceDetail: defHTTP<{ id: string }, Invoice>('GET', '/api/invoice/:id'),

  /**
   * Cancel invoice application
   */
  cancelInvoice: defHTTP<{ id: string }, void>('DELETE', '/api/invoice/:id'),
};
